import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * Mobile-only inline banner — full-width, text-first, shown between product
 * rows (typically after the 2nd–3rd product). Lighter footprint than the
 * desktop tile; renders no imagery to keep mobile data usage low.
 */
export const CompareBannerMobile = () => (
  <a
    href="/compare"
    data-testid="compare-promo-banner-mobile"
    className="
      block sm:hidden
      bg-stone-100 border border-stone-200 rounded-lg
      px-5 py-4
      hover:bg-stone-150 active:bg-stone-200 transition-colors
    "
  >
    <h3 className="font-bold text-base text-stone-900 mb-1">
      Not Sure Which One to Choose?
    </h3>
    <p className="text-sm text-stone-600 leading-snug mb-3">
      Select products to compare features and specs in one view.
    </p>
    <span
      data-testid="compare-promo-banner-mobile-cta"
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary"
    >
      Compare Products
      <ArrowRight className="w-4 h-4" />
    </span>
  </a>
);

export default CompareBannerMobile;
